import React from 'react';
import aquaristFullLogo from 'assets/images/aquarist/aquaristFullLogo.png';
import aquaristScreenshots from 'assets/images/aquarist/aquaristScreenshots.png';
import { Text } from 'atoms';
import { color, size, weight } from 'designs';
import { AppStoreButtons } from 'molecules';
import {
  AQUARIST_ANDROID_URL,
  AQUARIST_FEATURES,
  AQUARIST_IOS_URL,
} from 'data';

const AquaristHeroSection: React.FC = () => {
  return (
    <>
      <section className="aquarist-hero">
        <div className="aquarist-hero-shots">
          <img
            src={aquaristScreenshots}
            alt="Aquarist app screenshots"
            className="aquarist-hero-shots-img"
          />
        </div>

        <div className="aquarist-hero-copy">
          <img
            src={aquaristFullLogo}
            alt="Aquarist"
            className="aquarist-hero-name"
          />
          <Text
            as="p"
            className="aquarist-hero-subtitle"
            size={size.medium}
            weight={weight.medium}
            color={color.aquaristPrimary}
          >
            Your Ultimate Fishkeeping Companion
          </Text>
          <Text
            as="p"
            className="aquarist-hero-headline"
            size={size.display}
            weight={weight.bold}
            color={color.aquaristDeep}
          >
            Track. Plan. Research.
          </Text>
          <Text
            as="p"
            className="aquarist-hero-tagline"
            size={size.xlarge}
            weight={weight.medium}
            color={color.aquaristMuted}
          >
            Everything for the modern fishkeeper, in one app.
          </Text>
          <AppStoreButtons
            iosUrl={AQUARIST_IOS_URL}
            androidUrl={AQUARIST_ANDROID_URL}
          />
        </div>
      </section>

      <section className="aquarist-features">
        {AQUARIST_FEATURES.map((feature) => (
          <div className="aquarist-feature" key={feature.title}>
            <Text
              as="h2"
              className="aquarist-feature-title"
              size={size.xlarge}
              weight={weight.semibold}
              color={color.aquaristDeep}
            >
              {feature.title}
            </Text>
            <Text
              as="p"
              className="aquarist-feature-body"
              color={color.aquaristBody}
            >
              {feature.body}
            </Text>
          </div>
        ))}
      </section>
    </>
  );
};

export default AquaristHeroSection;
